'use strict';
angular.module('manageCfg.roleManageMent.permissionAssignment.SavePerModule', []).
controller('SavePerModuleController', ["$scope", "$rootScope", "trsHttpService", "modalDialog", function($scope, $rootScope, trsHttpService, modalDialog) {
    $scope.cancel = function() {
        $scope.$close();
    };
    $scope.savePer = function() {
        var TemplateDefIds = "";
        angular.forEach($scope.authorSelectedNode.RIGHTVALUE, function(data, index, array) {
            TemplateDefIds += data;
        });
        var savePer = {
            "serviceid": "mlf_righttemplate",
            "methodname": "save",
            "ObjectId": 0,
            "NEWVALUE": TemplateDefIds,
            "RIGHTTEMPLATENAME": $scope.templateName
        };
        trsHttpService.httpServer("/wcm/mlfcenter.do", savePer, "post").then(function(data) {
            modalDialog.alertType("保存成功", "", "success", false);
            $rootScope.$broadcast("savaPerSuccess", true);
            $scope.$close();
        });

    };
}]);